module.exports = __webpack_public_path__ + "media/10.c13abe1f.mp3";